import { render, staticRenderFns } from "./EmployeePositionDescription.vue?vue&type=template&id=53540d62&scoped=true&"
import script from "./EmployeePositionDescription.vue?vue&type=script&lang=js&"
export * from "./EmployeePositionDescription.vue?vue&type=script&lang=js&"
import style0 from "./EmployeePositionDescription.vue?vue&type=style&index=0&id=53540d62&scoped=true&lang=css&"
import style1 from "./EmployeePositionDescription.vue?vue&type=style&index=1&media=print&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53540d62",
  null
  
)

export default component.exports